/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_Copy_SuffixInputs */



/**
* | output |
* | --- |
* | "(checkpoint copy)" |
*
* @param {Assistant_Restore_Copy_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_copy_suffix = /** @type {((inputs?: Assistant_Restore_Copy_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Copy_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("(copie du point de contrôle)")
	if (locale === "de") return /** @type {LocalizedString} */ ("(Checkpoint-Kopie)")
	if (locale === "it") return /** @type {LocalizedString} */ ("(copia del checkpoint)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("(копия контрольной точки)")
	if (locale === "es") return /** @type {LocalizedString} */ ("(copia del punto de control)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（检查点副本）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("（チェックポイントコピー）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("(चेकपॉइंट कॉपी)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("(cópia do ponto de verificação)")
	return /** @type {LocalizedString} */ ("(checkpoint copy)")
});